import { render, staticRenderFns } from "./ReminderDetail.vue?vue&type=template&id=280dcbb6"
import script from "./ReminderDetail.vue?vue&type=script&lang=js"
export * from "./ReminderDetail.vue?vue&type=script&lang=js"
import style0 from "./ReminderDetail.vue?vue&type=style&index=0&id=280dcbb6&prod&lang=scss&scpoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports